module.exports = __webpack_public_path__ + "media/images/athletes/512-f3a58585849c28269f8a53ae11d20169.png";